var $link = $('.brand-icons-pictograms .icons div a');

$link.hover(function() {
    $(this).parent().children('h3').addClass('hover-color');
}, function() {
    $(this).parent().children('h3').removeClass('hover-color');
});